import { Injectable } from '@angular/core';
import { HttpObject } from '../../enum/http-object.enum';
@Injectable()
export class CookiesService {

  constructor() { }
  setCookies(name: string, value: string, expires: number, path: string = '') : void {
        document.cookie = name +"=" +value + ";  expires=-1" ;
       // let d:Date = new Date();
       // d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
     //  d.setTime(d.getTime() + expireTime * 1000);
      //  let expires:string = "expires="+ d.toUTCString();
       // let cpath:string = path ? "; path= " + path + "" : '';
       //Cookie.set("test", "", expire);
       // document.cookie = name +"=" + HttpObject.AUTHTYPE.toString() + ' '+value + ";"+expires + cpath;
      let cookieStr = encodeURIComponent(name) + '='+ HttpObject.AUTHTYPE.toString() + ' ' + encodeURIComponent(value) + ';';

		if (expires) {
			//let dtExpires = new Date(new Date().getTime() + expires * 1000);
                        //cookieStr += ' expires=' + dtExpires.toUTCString() + ';';
                  let dtExpires = new Date(new Date().getTime() + expires * 1000 - (3600 * 5));
			cookieStr += ' expires=' + dtExpires.toUTCString() + ';';
		}

		if (path) {
			cookieStr += 'path=' + path + ';';
		}
		/*if (domain) {
			cookieStr += 'domain=' + domain + ';';
		}
		if (secure) {
			cookieStr += 'secure;';
		}*/

		// console.log(cookieStr);
            document.cookie = cookieStr;
           
      }
  setOtherCookies(name: string, value: string, expireTime: number, path: string = 'MYSKINKLINIC') : void {
       document.cookie = name +"=" +value + ";  expires=-1" ;
        let d:Date = new Date(new Date().getTime() + expireTime * 1000 - (3600 * 5));
       // d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
        
        let expires:string = "expires="+ d.toUTCString();
        let cpath:string = path ? "; path= " + path + "" : '';
        document.cookie = name +"=" +value + "; "+expires + cpath;
  }
  getCookies(name : string) : string {
        let ca: Array<string> = document.cookie.split(';');
        let caLen: number = ca.length;
        let cookieName = name+ "=";
        let c: string;
        for (let i: number = 0; i < caLen; i += 1) {
            c = ca[i].replace(/^\s+/g, '');
            if (c.indexOf(cookieName) == 0) {
                return c.substring(cookieName.length, c.length);
            }
        }
        return '';
  }
  deleteCookie (name : string) : void {
        this.setCookies(name, '', -1);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/service/cookies/cookies.service.ts